import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { approvePartnerSubmission, getDbmQaPartnerSubmissions, rejectPartnerSubmission } from "../../../redux/actions/partnerSubmissions"
import { Table, Modal, Checkbox } from 'rsuite'
import LoaderComponent from "../../CommonComponents/LoaderComponent"
import { getAbbreviatedState } from "../../../services/helper"
import moment from "moment"
import { Link } from "react-router-dom/cjs/react-router-dom.min"
import QAList from "../listInformationModal/qaList"
import { getLocationMastersByMasterIds, getSuppliersDataByIds } from "../../../redux/actions/vendor"
import { toast } from "../../CommonComponents/ToastComponent/toast"
import ModalComponent from "../../CommonComponents/Modal"
const { Column, HeaderCell, Cell, Pagination } = Table


export const LinkCell = ({ rowData, dataKey, ...props }) => {
    return (
        <Cell {...props} role="button" className="table-link list-table-cell text-black" id={rowData.id} title={rowData[dataKey]}>
            <button style={{ width: '60px' }} className={`h4 mb-0 text-start`}>
                {rowData[dataKey]}
            </button>
        </Cell>
    )
}

export const TableCell = ({ rowData, dataKey, mastersData = [], partnersData = [], onClick, ...props }) => {
    let matchedColumns = ['matchedAddress1', 'matchedCity', 'matchedState', 'matchedZip']
    if (dataKey === 'state' && rowData[dataKey]) {
        rowData[dataKey] = getAbbreviatedState('', rowData[dataKey])
    }
    if (dataKey === 'createdAt') {
        const importedDate = rowData?.['createdAt'] ? moment(rowData?.['createdAt']).format('MM/DD/YYYY') : '';
        rowData[dataKey] = importedDate
    }
    if (dataKey === 'acceptanceType') {
        let masterDetails = mastersData?.find(sup => sup?.id === rowData?.matchedSupplierId)
        rowData[dataKey] = masterDetails?.acceptanceType || ''
    }

    if (dataKey === 'masterSupplierName') {
        let masterDetails = mastersData?.find(sup => sup?.id === rowData?.matchedSupplierId)
        rowData[dataKey] = <Link target="_blank" to={`/suppliers/${masterDetails?.masterSupplierId}`}>{masterDetails?.masterSupplierName}</Link>
    }

    if (dataKey === 'matchedSupplierName') {
        let supplier = mastersData?.find((sup) => sup?.id === rowData?.matchedSupplierId)
        if (supplier?.isMaster && !supplier?.masterId) {
            rowData[dataKey] = <Link target="_blank" to={`/suppliers/${supplier?.id}`}>{supplier?.suppliername}</Link>
        } else {
            rowData[dataKey] = <Link target="_blank" to={`/suppliers/relatedsupplier/${supplier?.id}`}>{supplier?.suppliername}</Link>
        }
    }

    if (matchedColumns?.includes(dataKey)) {
        const key = dataKey?.replaceAll('matched', '')?.toLowerCase()
        let supplier = mastersData?.find((sup) => sup?.id === rowData?.matchedSupplierId)
        rowData[dataKey] = supplier?.[key] || ''
    }

    if (dataKey === 'matchStatus') {
        rowData[dataKey] = rowData?.matchedSupplierId ? 'Matched' : 'Unmatched'
    }

    if (dataKey === 'partnerName') {
        let partner = partnersData?.find((data) => data?.id === rowData?.partnerId)
        rowData[dataKey] = partner?.partnerName || ''
    }

    return (
        <Cell {...props} className="table-link table-cell text-black" id={rowData.id} title={rowData[dataKey]}>
            {rowData[dataKey]}
        </Cell>
    )
}

const QaResults = ({ setIsRefresh }) => {
    const tabs = [
        { label: 'DBM QA', value: 'dbm' },
        { label: 'Calls QA', value: 'calls' }
    ]

    const dbmQaColumns = [
        { name: 'suppliername', label: 'Supplier Name', sortable: true },
        { name: 'partnerName', label: 'Partner Name' },
        { name: 'partnerCompanyId', label: 'Company Id' },
        { name: 'matchScore', label: 'Match Score', sortable: true },
        { name: 'matchStatus', label: 'Match Status' },
        { name: 'address1', label: 'Address', sortable: true },
        { name: 'city', label: 'City', sortable: true },
        { name: 'state', label: 'State', sortable: true },
        { name: 'zip', label: 'Zip', sortable: true },
        { name: 'campaignType', label: 'Service Type', sortable: true },
        { name: 'acceptanceType', label: 'Acceptance Type' },
        { name: 'matchedSupplierName', label: 'Matched Supplier Name' },
        { name: 'masterSupplierName', label: 'Master Supplier' },
        { name: 'matchedAddress1', label: 'Matched Address' },
        { name: 'matchedCity', label: 'Matched City' },
        { name: 'matchedState', label: 'Matched State' },
        { name: 'matchedZip', label: 'Matched Zip' },
        { name: 'createdAt', label: 'Date Imported', sortable: true }
    ]

    const dispatch = useDispatch()
    const [isLoading, setIsLoading] = useState(false)
    const [currentTab, setCurrentTab] = useState('dbm')
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [tableData, setTableData] = useState([])
    const [totalData, setTotalData] = useState(0)
    const [sortColumn, setSortColumn] = useState('suppliername')
    const [sortType, setSortType] = useState('asc')
    const [checkedKeys, setCheckedKeys] = useState([])
    const [selectedPartnerSubmissions, setSelectedPartnerSubmissions] = useState([])
    const [showQaListModal, setShowQaListModal] = useState(false)
    const [masterSupplierList, setMasterSupplierList] = useState([])
    const [partnersData, setPartnersData] = useState([])
    const [showRejectConfirm, setShowRejectConfirm] = useState(false)
    const [searchValue, setSearchValue] = useState("");

    let checked = false;
    let indeterminate = false;

    if (checkedKeys?.length === tableData?.length) {
        checked = true;
    } else if (checkedKeys?.length === 0) {
        checked = false;
    } else if (checkedKeys?.length > 0 && checkedKeys?.length < tableData?.length) {
        indeterminate = true;
    }

    useEffect(() => {
        if (currentTab === 'dbm') {
            getQaTableData({})
        }
        if (currentTab === 'calls') {

        }
    }, [currentTab])

    const handleChangeLimit = (dataKey) => {
        setPage(1);
        setLimit(dataKey);
        getQaTableData({ limit: dataKey, page: 1 })
    }

    const handleChangePage = (page) => {
        setPage(page)
        getQaTableData({ limit, page, sortColumn, sortType })
    }

    const handleSortColumn = (sortColumn, sortType) => {
        setSortColumn(sortColumn);
        setSortType(sortType);
        getQaTableData({ limit, page, sortColumn, sortType })
    }

    const getQaTableData = async ({ limit = 10, page = 1, sortColumn = 'suppliername', sortType = 'asc', searchValue }) => {
        setIsLoading(true)
        dispatch(getDbmQaPartnerSubmissions({
            limit,
            offset: limit * (page - 1),
            sortColumn,
            sortType,
            searchData: searchValue
        })).then(async (res) => {
            let finalResponse = []
            let matchedSuppliersIds = res?.rows?.map(data => data?.matchedSupplierId)
            if (matchedSuppliersIds?.length) {
                await dispatch(getSuppliersDataByIds(matchedSuppliersIds, [], true)).then(async (res) => {
                    let mainMasterIds = res.filter(sup => sup?.isAcceptGlobalAcceptance === false)?.map(sup => sup?.masterSupplierId)

                    let locationMasters = []
                    if (mainMasterIds?.length > 0) {
                        locationMasters = await dispatch(getLocationMastersByMasterIds(mainMasterIds)).then((locMasters) => {
                            return locMasters
                        }).catch(() => {
                            toast.show({
                                title: 'Warning',
                                description: 'Failed To Get Location Masters',
                            })
                            return []
                        })
                    }
                    finalResponse = res.map(sup => {
                        let locationMas = locationMasters?.find(master => master.masterId === sup.masterSupplierId)
                        if (sup?.isAcceptGlobalAcceptance === true) {
                            sup.acceptanceType = 'Global'
                        } else if (sup?.isAcceptGlobalAcceptance === null) {
                            sup.acceptanceType = 'Unknown'
                        } else if (locationMas && locationMas?.id) {
                            sup.acceptanceType = 'Location'
                        } else {
                            sup.acceptanceType = 'Selective'
                        }
                        return sup
                    })
                    setMasterSupplierList(finalResponse)
                }).catch(() => {
                    toast.show({
                        title: 'Warning',
                        description: 'Failed To Get Master Suppliers Data!',
                    })
                })
            }

            setTableData(res?.rows || [])
            setTotalData(res?.total || 0)
            setPartnersData(res?.partnersData || [])
            setCheckedKeys([])
            setSelectedPartnerSubmissions([])
            setIsLoading(false)
        }).catch(() => {
            setTableData([])
            setTotalData(0)
            setPartnersData([])
            setCheckedKeys([])
            setSelectedPartnerSubmissions([])
            setIsLoading(false)
            toast.show({
                title: 'Warning',
                description: 'Failed to get QA data!'
            })
        })
    }

    const handleClickTab = (tab) => {
        setCurrentTab(tab)
        setSearchValue("")
    }

    const partnerNameSearchHandler = (e) => {
        setSearchValue(e.target.value)
    }

    const handleCheckAll = (value, checked) => {
        const keys = checked ? tableData?.map(item => item.id) : [];
        setCheckedKeys(keys);
    };

    const handleCheck = (value, checked) => {
        const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
        const selectedPendingSups = [...selectedPartnerSubmissions]

        let isExist = selectedPendingSups.some(supplier => supplier.id === value)
        if (!isExist) {
            const sup = tableData.filter(supplier => supplier.id === value)
            selectedPendingSups.push(sup[0])
        } else {
            const index = selectedPendingSups.findIndex(supplier => supplier.id === value)
            if (index !== -1) {
                selectedPendingSups.splice(index, 1)
            }
        }
        setSelectedPartnerSubmissions(selectedPendingSups)
        setCheckedKeys(keys);
    };

    const onClose = (isRefreshData = false) => {
        setShowQaListModal(false)
        setIsRefresh(isRefreshData)
        if (isRefreshData) {
            getQaTableData(limit, 1, sortColumn, sortType)
        }
    }

    const onQaListClick = () => {
        setShowQaListModal(true)
    }

    const onApprove = async () => {
        if (checkedKeys?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No data selected to approve!',
            })
            return
        }
        setIsLoading(true)
        for (let i = 0; i < checkedKeys?.length; i++) {
            const id = checkedKeys?.[i]
            await dispatch(approvePartnerSubmission({ submissionId: id })).then(async () => {
            }).catch(err => {
                toast.show({
                    title: 'Warning',
                    description: err?.response?.data?.message ? 'Server Error: ' + err?.response?.data?.message : 'Failed to approve!'
                })
            })
        }
        setIsLoading(false)
        getQaTableData(limit, 1, sortColumn, sortType)
    }

    const onReject = async () => {
        setShowRejectConfirm(true)
    }

    const onRejectConfirmation = async () => {
        if (checkedKeys?.length === 0) {
            toast.show({
                title: 'Warning',
                description: 'No data selected to approve!',
            })
            return
        }
        setIsLoading(true)
        await dispatch(rejectPartnerSubmission({ submissionIds: checkedKeys })).then(async () => {
        }).catch(err => {
            toast.show({
                title: 'Warning',
                description: err?.response?.data?.message ? 'Server Error: ' + err?.response?.data?.message : 'Failed to reject partner submissions!'
            })
        })
        setIsLoading(false)
        getQaTableData(limit, 1, sortColumn, sortType)
        setShowRejectConfirm(false)
    }

    const headerElements = (columns) => {
        return columns.map((col, index) => {
            return (
                <Column
                    resizable
                    sortable={col?.sortable || false}
                    key={col.name}
                >
                    <HeaderCell className='fw-bold text-black'>{col.label}</HeaderCell>
                    <TableCell className='text-black' dataKey={col.name} mastersData={masterSupplierList} partnersData={partnersData} />
                </Column>
            )
        })
    }

    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
        <Cell {...props} style={{ padding: 0 }}>
            <Checkbox
                value={rowData[dataKey]}
                onChange={onChange}
                checked={checkedKeys.some(item => item === rowData[dataKey])}
            />
        </Cell>
    )

    const handleResetCheckedTableData = (id) => {
        const tmpCheckedIds = checkedKeys?.filter(key => key !== id)
        const tmpCheckedRows = selectedPartnerSubmissions?.filter(data => data?.id !== id)
        setCheckedKeys(tmpCheckedIds)
        setSelectedPartnerSubmissions(tmpCheckedRows)
    }

    return (
        <div className="qa-results">
            <div className='d-flex w-50 gap-4 align-items-center '>
                <input
                    type="text"
                    className=" search-input w-50 shadow-none h5 mb-0 "
                    placeholder='Supplier name'
                    onChange={(event) => partnerNameSearchHandler(event)}
                    value={searchValue}
                    disabled={isLoading}
                />
                <div className='d-flex align-items-center w-50 gap-4'>
                    <button
                        className='pt-3 pb-3 p-5 bg-green border-0 rounded text-white h4 mb-0'
                        onClick={() => { searchValue?.trim() && getQaTableData({ searchValue: searchValue?.trim() }) }}
                        disabled={isLoading}
                    >
                        Search
                    </button>
                    <button
                        className='pt-3 pb-3 p-5 bg-gray border-0 rounded text-white h4 mb-0'
                        onClick={(e) => {
                            getQaTableData({ limit: 10, page: 1, sortColumn: 'suppliername', sortType: 'asc' });
                            setSearchValue(""); setPage(1)
                        }}
                        disabled={isLoading || !searchValue?.trim()}
                    >
                        Clear
                    </button>
                </div>
            </div>
            <div className='d-flex'>
                <div className='page-tabs gap-4 gap-md-5'>
                    {
                        tabs.map(tab => {
                            return <button
                                key={tab.value}
                                type="button"
                                className={`page-tab me-0${currentTab === tab.value ? ' selected' : ''}`}
                                onClick={() => { handleClickTab(tab.value) }}
                            >
                                {tab.label}
                            </button>
                        })
                    }
                </div>
                <div className='d-flex column-gap-3 ms-auto'>
                    <button className='report_button_blue' disabled={isLoading || totalData === 0} onClick={() => { onQaListClick() }}>QA</button>
                    <button className='report_button_danger' disabled={isLoading || checkedKeys?.length === 0 && true} onClick={onReject}>Reject</button>
                    <button className='report_button_success' disabled={isLoading || checkedKeys?.length === 0 && true} onClick={onApprove}>Approve</button>
                </div>
            </div>
            <div className={`position-relative mt-4 border border-2 rounded ${isLoading ? 'loading' : ''}`}>
                {isLoading && <LoaderComponent />}
                <Table
                    virtualized={true}
                    // autoHeight
                    height={520}
                    affixHeader={true}
                    data={tableData}
                    className='partner-sub-qa-table'
                    sortColumn={sortColumn}
                    sortType={sortType}
                    onSortColumn={handleSortColumn}
                >
                    <Column width={50} align="center" fixed>
                        <HeaderCell style={{ padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Checkbox
                                checked={checked}
                                indeterminate={indeterminate}
                                onChange={handleCheckAll}
                            />
                        </HeaderCell>
                        <CheckCell
                            dataKey="id"
                            checkedKeys={checkedKeys}
                            onChange={handleCheck}
                        />
                    </Column>
                    {headerElements(currentTab === 'dbm' ? dbmQaColumns : dbmQaColumns)}
                </Table>
                <div className="my-list-table-pagination">
                    <Pagination
                        prev
                        next
                        first={true}
                        last={true}
                        maxButtons={5}
                        activePage={page}
                        showInfo
                        displayLength={limit}
                        lengthMenu={[
                            {
                                label: '10',
                                value: 10,
                            },
                            {
                                label: '20',
                                value: 20,
                            },
                            {
                                label: '30',
                                value: 30,
                            },
                            {
                                label: '50',
                                value: 50,
                            },
                            {
                                label: '100',
                                value: 100,
                            },
                        ]}
                        total={totalData}
                        onChangeLength={handleChangeLimit}
                        onChangePage={(event) => { handleChangePage(event) }}
                    />
                </div>
            </div>
            {showQaListModal &&
                <QAList
                    show={showQaListModal}
                    onGoBack={onClose}
                    allVendors={checkedKeys?.length > 0 ? selectedPartnerSubmissions : tableData}
                    page='partnerSubmission'
                    checkedKeys={checkedKeys}
                    resetCheckedTableData={handleResetCheckedTableData}
                />
            }
            {
                showRejectConfirm && (
                    <ModalComponent
                        size='md'
                        modalTitle='Are you sure you want to reject the selected records?'
                        open={showRejectConfirm}
                        handleClose={() => { setShowRejectConfirm(false) }}
                        isLoading={isLoading}
                    >
                        <div className='d-flex column-gap-3'>
                            <button className='report_small_button_grey' onClick={() => { setShowRejectConfirm(false) }}>Cancel</button>
                            <button className='report_small_button_danger' onClick={onRejectConfirmation}>Reject</button>
                        </div>
                    </ModalComponent>
                )
            }
        </div>
    )
}

export default QaResults